import { render, staticRenderFns } from "./WidgetMetadataRecordsPez.vue?vue&type=template&id=3b0d9b78&"
import script from "./WidgetMetadataRecordsPez.vue?vue&type=script&lang=js&"
export * from "./WidgetMetadataRecordsPez.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetMetadataRecordsPez.vue"
export default component.exports